import { uploadImage } from "@/services/upload";
import { Add } from "@mui/icons-material";
import { Box, Button, Card, CardMedia, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export default function NewMerchContainer({ meta, setMeta }) {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [price, setPrice] = useState("");
  const [file, setFile] = useState(null); // cover is the file

  useEffect(() => {
    setMeta((prev) => ({ ...prev, title, link, price }));
  }, [title, link, price]);

  const handleFileChange = async (e) => {
    const cover = await uploadImage(file);
    setMeta((prev) => ({ ...prev, cover }));
  };

  useEffect(() => {
    if (file) {
      handleFileChange(file);
    }
  }, [file]);

  const handlePriceChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    setPrice(value);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 4,
          mt: 2,
        }}
      >
        <Card style={{ borderRadius: "20px" }} sx={{ px: 2, mb: 4, py: 4 }}>
          {!file && (
            <Box>
              <label htmlFor="icon-button-file-merch">
                <Button
                  variant="outlined"
                  color="secondary"
                  component="span"
                  fullWidth
                  style={{ borderRadius: "25px" }}
                  startIcon={<Add />}
                >
                  Add Photo
                </Button>
              </label>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="icon-button-file-merch"
                type="file"
                // multiple
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Box>
          )}

          <CardMedia
            component="img"
            src={file ? URL.createObjectURL(file) : ""}
            style={{ borderRadius: "10px" }}
          />

          <TextField
            fullWidth
            autoComplete="off"
            color="secondary"
            label="Price"
            value={price}
            variant="standard"
            onChange={handlePriceChange}
            margin="normal"
            placeholder="Enter the price of the item."
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            required
          />

          <TextField
            fullWidth
            autoComplete="off"
            color="secondary"
            label="Store Link"
            placeholder="https://shop.yourmerchstore.com/item?key=notebook"
            value={link}
            variant="standard"
            onChange={(e) => setLink(e.target.value)}
            margin="normal"
            helperText="Add a link to item on your store."
            required
          />

          <TextField
            fullWidth
            autoComplete="off"
            color="secondary"
            label="Title"
            value={title}
            variant="standard"
            onChange={(e) => setTitle(e.target.value)}
            margin="normal"
            required
          />
        </Card>
      </Box>
    </Box>
  );
}
